import Vue from "vue";
import Vuex from "vuex";
import imagesService from "../api/images";

Vue.use(Vuex);

const initialState = {
  personImages: [],
  currentPersonImage: null,
  imagesOrder: []
};

const getters = {
  personImages(state) {
    return state.personImages;
  },
  currentPersonImage(state) {
    return state.currentPersonImage;
  },
  imagesOrder(state) {
    return state.imagesOrder
  }
};

export const mutations = {
  setImageOrder(state, payload) {
    state.imagesOrder = payload
  }
}

export const actions = {
  async saveImagesOrder(context, payload) {
    try {
      const response = await imagesService.saveImagesOrder(payload);
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getImagesOrder(context, payload) {
    try {
      const response = await imagesService.getImagesOrder(payload);
      context.state.imagesOrder = response.data;
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getPersonImages(context, payload) {
    try {
      const response = await imagesService.getPersonImages(payload);
      context.state.personImages = response.data;
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getPersonImageById(context, payload) {
    try {
      const response = await imagesService.getPersonImageById(payload);
      context.state.currentPersonImage =
        response.data.image
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async updateImageDetails(context, payload) {
    try {
      const response = await imagesService.updateImageDetails(payload);
      context.commit('toast', { message: context.rootState.langObj.response.success.changed, color: 'black' }, { root: true })
      return Promise.resolve();
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async deletePersonImage(context, payload) {
    try {
      const response = await imagesService.deletePersonImage(payload);
      context.commit('toast', { message: context.rootState.langObj.response.success.deleteImage, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  }
};

export const state = { ...initialState };

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
